/**
 * avatars/aliens/species/species-batch3.js
 * Dữ liệu chủng tộc văn minh (Nhóm 3).
 */

import {
  SPECIES_STEAMPUNK,
  SPECIES_FULGOR,
  SPECIES_ASTRAL,
  SPECIES_ZEPHYR,
  SPECIES_RADIATION,
  SPECIES_GRAVITON,
  SPECIES_CHRONO,
  SPECIES_NEBULA,
  SPECIES_VOID,
  SPECIES_SINGULARITY
} from '../species-ids.js';

export const SPECIES_BATCH_3 = {
  [SPECIES_STEAMPUNK]: {
    speciesId: 'species_steampunk',
    shortName: 'Kỹ Sư Cơ Khí Bánh Răng Đồng',
    cardSubtitle: 'Steam-Cog • Bánh răng đồng',
    name: 'Kỹ Sư Cơ Khí Bánh Răng Đồng (Steam-Cog)',
    planet: 'Steam-Cog',
    lore: 'Cộng đồng các nhà cơ khí tài ba tại thủ phủ bánh răng Steam-Cog. Họ làm chủ công nghệ động cơ hơi nước áp suất siêu cao và hệ thống truyền động bánh răng vi mô tinh xảo.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào bạn đồng hành! Áp suất hơi nước hôm nay thật hoàn hảo cho một cuộc hội ngộ.'
      },
      {
        action: 'explain',
        text: 'Mỗi bánh răng đồng đều ăn khớp nhịp nhàng, biểu trưng cho sự gắn kết hài hòa trong xã hội chúng tôi.'
      },
      {
        action: 'present',
        text: 'Kính bảo hộ đo áp suất giúp chúng tôi kiểm tra độ an toàn tuyệt đối của mọi hệ thống hơi nước.'
      }
    ],
    dna: {
      skinColor: '#d4a373',
      eyeType: 'cyber_visor',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#451a03',
      eyeColor: '#d97706',
      pantsColor: '#365314',
      shoesColor: '#1c1917'
    },
    clothing: {
      maleOutfit: 'steampunk_male',
      femaleOutfit: 'steampunk_female',
      shirtPalette: ['#78350f', '#451a03', '#854d0e', '#57534e']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_FULGOR]: {
    speciesId: 'species_fulgor',
    shortName: 'Cư Dân Điện Từ Sấm Sét',
    cardSubtitle: 'Voltaria • Hồ quang ion',
    name: 'Cư Dân Điện Từ Sấm Sét (Voltaria)',
    planet: 'Voltaria',
    lore: 'Xã hội năng động tại tinh cầu bão từ Voltaria. Cơ thể họ tích điện trường ion sạch và làm chủ mạng lưới năng lượng tái tạo hồ quang điện cung cấp cho toàn hành tinh.',
    reactions: [
      {
        action: 'wave',
        text: 'Điện thế hữu nghị từ Voltaria xin gửi đến bạn nguồn năng lượng tích cực nhất!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi tích trữ các dòng sét tự nhiên để thắp sáng và vận hành các phương tiện công cộng không khí thải.'
      },
      {
        action: 'present',
        text: 'Y phục của chúng tôi có nẹp điện cực cách điện đa lớp, bảo đảm an toàn tuyệt đối cho người đối thoại.'
      }
    ],
    dna: {
      skinColor: '#38bdf8',
      eyeType: 'fire',
      horns: 'tesla_antennae',
      wings: 'none',
      tail: 'none',
      hairColor: '#075985',
      eyeColor: '#38bdf8',
      pantsColor: '#0c4a6e',
      shoesColor: '#082f49'
    },
    clothing: {
      maleOutfit: 'fulgor_male',
      femaleOutfit: 'fulgor_female',
      shirtPalette: ['#0284c7', '#0369a1', '#075985', '#0c4a6e']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'spiky'
    }
  },

  [SPECIES_ASTRAL]: {
    speciesId: 'species_astral',
    shortName: 'Người Tinh Vân Dạ Khúc',
    cardSubtitle: 'Stardust-Nova • Bụi sao tinh tú',
    name: 'Người Tinh Vân Dạ Khúc (Stardust-Nova)',
    planet: 'Stardust-Nova',
    lore: 'Những nhà chiêm tinh và nghệ sĩ của chòm sao Stardust-Nova. Làn da họ lấp lánh bụi sao và trang phục dệt từ ánh sáng thiên hà, lưu giữ những bản hòa ca vũ trụ từ thuở sơ khai.',
    reactions: [
      {
        action: 'wave',
        text: 'Giai điệu tinh tú từ Stardust-Nova ngân vang đón chào người bạn phương xa!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi lắng nghe tần số dao động của các vì sao và dệt chúng thành những khúc ca hòa bình liên ngân hà.'
      },
      {
        action: 'present',
        text: 'Áo choàng bụi sao phản chiếu bản đồ chuyển động của hàng triệu chòm sao trong đêm tĩnh lặng.'
      }
    ],
    dna: {
      skinColor: '#818cf8',
      eyeType: 'star',
      horns: 'none',
      wings: 'angel_wings',
      tail: 'none',
      hairColor: '#1e1b4b',
      eyeColor: '#818cf8',
      pantsColor: '#312e81',
      shoesColor: '#0f172a'
    },
    clothing: {
      maleOutfit: 'astral_male',
      femaleOutfit: 'astral_female',
      shirtPalette: ['#312e81', '#3730a3', '#4338ca', '#1e1b4b']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_ZEPHYR]: {
    speciesId: 'species_zephyr',
    shortName: 'Người Gió Khí Quyển',
    cardSubtitle: 'Aetheria • Cánh phong vân',
    name: 'Người Gió Khí Quyển (Aetheria)',
    planet: 'Aetheria',
    lore: 'Cư dân của các thành phố nổi bồng bềnh giữa tầng mây Aetheria. Họ sở hữu đôi cánh phong vân thanh thoát và công nghệ điều hòa khí quyển vi mô, bảo tồn luồng gió mát lành nuôi dưỡng hệ sinh thái.',
    reactions: [
      {
        action: 'wave',
        text: 'Luồng gió thanh mát từ Aetheria xin gửi lời chào sảng khoái đến bạn!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi nương theo các dòng đối lưu không khí để bay lượn và sản sinh năng lượng phong điện sạch.'
      },
      {
        action: 'present',
        text: 'Đôi cánh phong vân nhẹ tựa tơ trời giúp chúng tôi lướt êm ái trên các tầng mây tầng cao.'
      }
    ],
    dna: {
      skinColor: '#bae6fd',
      eyeType: 'star',
      wings: 'angel_wings',
      horns: 'none',
      tail: 'none',
      hairColor: '#bae6fd',
      eyeColor: '#38bdf8',
      pantsColor: '#0369a1',
      shoesColor: '#0c4a6e'
    },
    clothing: {
      maleOutfit: 'zephyr_male',
      femaleOutfit: 'zephyr_female',
      shirtPalette: ['#0284c7', '#38bdf8', '#7dd3fc', '#0369a1']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_RADIATION]: {
    speciesId: 'species_radiation',
    shortName: 'Cư Dân Bức Xạ Năng Lượng',
    cardSubtitle: 'Radia-66 • Bộ lọc quang năng',
    name: 'Cư Dân Bức Xạ Năng Lượng (Radia-66)',
    planet: 'Radia-66',
    lore: 'Các nhà nghiên cứu quang năng và bức xạ đồng vị sạch tại Radia-66. Cơ thể họ có khả năng hấp thụ và chuyển hóa mọi loại bức xạ vũ trụ thành nguồn nhiệt điện nuôi sống các mái vòm sinh thái.',
    reactions: [
      {
        action: 'wave',
        text: 'Xin chào! Cảm biến bức xạ cho thấy môi trường tiếp đón hoàn toàn an toàn và tràn đầy năng lượng.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi thuần hóa bức xạ hạt nhân thành các dòng quang tử ấm áp nuôi sống thảm thực vật trong vòm kính.'
      },
      {
        action: 'present',
        text: 'Mặt nạ chuyên dụng này vừa là bộ điều áp, vừa là kính quang phổ phân tích môi trường xung quanh.'
      }
    ],
    dna: {
      skinColor: '#a3e635',
      eyeType: 'fire',
      hat: 'gas_mask_helm',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#365314',
      eyeColor: '#84cc16',
      pantsColor: '#3f6212',
      shoesColor: '#1a2e05'
    },
    clothing: {
      maleOutfit: 'radiation_male',
      femaleOutfit: 'radiation_female',
      shirtPalette: ['#4d7c0f', '#3f6212', '#65a30d', '#15803d']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_GRAVITON]: {
    speciesId: 'species_graviton',
    shortName: 'Nhà Vật Lý Trọng Lực',
    cardSubtitle: 'Baro-Prime • Động cơ 50G',
    name: 'Nhà Vật Lý Trọng Lực (Baro-Prime)',
    planet: 'Baro-Prime',
    lore: 'Nền văn minh khoa học kiên cường trên hành tinh siêu trọng lực 50G Baro-Prime. Cơ thể họ rắn rỏi và nắm vững công nghệ bẻ cong trường trọng lực, chế tạo các thiết bị du hành phản lực sạch.',
    reactions: [
      {
        action: 'wave',
        text: 'Cân bằng trọng lực đã ổn định! Baro-Prime nồng nhiệt chào đón bạn đến thăm.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi nghiên cứu cơ học không thời gian và chế tạo các bộ giảm áp trọng lực giúp du khách di chuyển nhẹ nhàng.'
      },
      {
        action: 'present',
        text: 'Bộ động cơ phản lực sau lưng giúp chúng tôi bay bổng tự do ngay cả trong vùng lực hấp dẫn cực đại.'
      }
    ],
    dna: {
      skinColor: '#78716c',
      eyeType: 'star',
      bodyAccessory: 'jetpack',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#1c1917',
      eyeColor: '#a8a29e',
      pantsColor: '#292524',
      shoesColor: '#0c0a09'
    },
    clothing: {
      maleOutfit: 'graviton_male',
      femaleOutfit: 'graviton_female',
      shirtPalette: ['#44403c', '#292524', '#57534e', '#1c1917']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'short_neat',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_CHRONO]: {
    speciesId: 'species_chrono',
    shortName: 'Người Gìn Giữ Thời Gian',
    cardSubtitle: 'Chronopolis • Con lắc thời không',
    name: 'Người Gìn Giữ Đồng Hồ Thời Gian (Chronopolis)',
    planet: 'Chronopolis',
    lore: 'Hội đồng các học giả thông thái tại kinh đô thời gian Chronopolis. Họ gìn giữ trục đồng hồ không thời gian và ghi chép biên niên sử của vạn vật vũ trụ, luôn trân trọng từng khoảnh khắc hiện tại.',
    reactions: [
      {
        action: 'wave',
        text: 'Từng tích tắc thời gian đều vô giá! Chronopolis hân hạnh đón tiếp bạn vào thời khắc tốt lành này.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi gìn giữ dòng thời gian vũ trụ chảy trôi hài hòa, nhắc nhở muôn loài trân quý từng phút giây hiện sinh.'
      },
      {
        action: 'present',
        text: 'Y phục của chúng tôi thêu bánh xe thiên văn và con lắc thời gian, biểu trưng cho sự bất biến của chân lý.'
      }
    ],
    dna: {
      skinColor: '#fde047',
      eyeType: 'star',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#713f12',
      eyeColor: '#fde047',
      pantsColor: '#854d0e',
      shoesColor: '#451a03'
    },
    clothing: {
      maleOutfit: 'chrono_male',
      femaleOutfit: 'chrono_female',
      shirtPalette: ['#ca8a04', '#a16207', '#854d0e', '#eab308']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_NEBULA]: {
    speciesId: 'species_nebula',
    shortName: 'Người Tinh Cầu Tinh Vân',
    cardSubtitle: 'Nebula-Prime • Bụi tinh vân tím',
    name: 'Người Tinh Cầu Tinh Vân (Nebula-Prime)',
    planet: 'Nebula-Prime',
    lore: 'Các cư dân uyên bác sinh sống giữa các vầng mây tinh vân vũ trụ rực rỡ. Cơ thể họ lấp lánh bụi khí plasma, trang phục lụa vũ trụ thêu chòm sao lung linh, mang đến sự thanh bình và vẻ đẹp bao la của vũ trụ.',
    reactions: [
      {
        action: 'wave',
        text: 'Ánh sáng tinh vân rực rỡ từ Nebula-Prime gửi lời chào thân ái nhất đến bạn!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi hấp thụ quang phổ năng lượng từ bụi sao để thắp sáng các thành phố vũ trụ bồng bềnh.'
      },
      {
        action: 'present',
        text: 'Màu tím huyền ảo của trang phục chúng tôi là sắc màu tự nhiên của các ion plasma liên sao.'
      }
    ],
    dna: {
      skinColor: '#c084fc',
      eyeType: 'star',
      horns: 'none',
      wings: 'aurora_ribbon',
      tail: 'none',
      hairColor: '#581c87',
      eyeColor: '#c084fc',
      pantsColor: '#6b21a8',
      shoesColor: '#3b0764'
    },
    clothing: {
      maleOutfit: 'nebula_male',
      femaleOutfit: 'nebula_female',
      shirtPalette: ['#9333ea', '#7e22ce', '#a855f7', '#6b21a8']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_VOID]: {
    speciesId: 'species_void',
    shortName: 'Cư Dân Hư Không Huyền Ảo',
    cardSubtitle: 'Umbra-9 • Chiều không gian tối',
    name: 'Cư Dân Hư Không Huyền Ảo (Umbra-9)',
    planet: 'Umbra-9',
    lore: 'Nền văn minh hiền hòa ngụ tại chiều không gian tối Umbra-9. Họ thấu hiểu sự tĩnh lặng tuyệt đối của chân không vũ trụ, khoác lên mình y phục giản dị lấp lánh những hạt vi mô lượng tử.',
    reactions: [
      {
        action: 'wave',
        text: 'Sự tĩnh lặng sâu lắng của Umbra-9 xin chào đón bạn bằng tất cả lòng chân thành.'
      },
      {
        action: 'explain',
        text: 'Hư không không phải là sự trống rỗng, mà là nơi khởi nguồn tiềm năng vô tận của mọi vật chất.'
      },
      {
        action: 'present',
        text: 'Trang phục bóng đêm của chúng tôi lưu giữ các hạt photon lượng tử điểm xuyết như bầu trời đêm.'
      }
    ],
    dna: {
      skinColor: '#475569',
      eyeType: 'void',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#312e81',
      eyeColor: '#c084fc',
      pantsColor: '#020617',
      shoesColor: '#020617'
    },
    clothing: {
      maleOutfit: 'void_male',
      femaleOutfit: 'void_female',
      shirtPalette: ['#0f172a', '#1e293b', '#334155', '#020617']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_SINGULARITY]: {
    speciesId: 'species_singularity',
    shortName: 'Học Giả Điểm Kỳ Dị',
    cardSubtitle: 'Singularis • Chân trời sự kiện',
    name: 'Học Giả Điểm Kỳ Dị Hố Đen (Singularis)',
    planet: 'Singularis',
    lore: 'Những học giả thông thái bậc nhất xây dựng trạm nghiên cứu tại chân trời sự kiện của hố đen Singularis. Họ khai thác năng lượng hấp dẫn để khám phá bí ẩn nguồn gốc của không thời gian.',
    reactions: [
      {
        action: 'wave',
        text: 'Chân trời sự kiện Singularis mở rộng vòng tay đón tiếp người bạn du hành can trường!'
      },
      {
        action: 'explain',
        text: 'Tại điểm kỳ dị, thời gian và không gian hòa quyện làm một, mở ra cánh cửa tri thức vĩnh cửu.'
      },
      {
        action: 'present',
        text: 'Vòng bồi tụ ánh sáng trên y phục là biểu tượng của định luật bảo toàn năng lượng tối thượng.'
      }
    ],
    dna: {
      skinColor: '#f1f5f9',
      eyeType: 'star',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#030712',
      eyeColor: '#60a5fa',
      pantsColor: '#172554',
      shoesColor: '#020617'
    },
    clothing: {
      maleOutfit: 'singularity_male',
      femaleOutfit: 'singularity_female',
      shirtPalette: ['#0f172a', '#3b82f6', '#1d4ed8', '#172554']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'short_neat',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  }
};
